import React, {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {CTAButton} from '../cta-button/cta-button.component';
import {Modal} from '../modal/modal.component';
import {ReactComponent as Envelope} from '../../assets/envelope.svg';

export const ResetPasswordModal: FC = () => {
  const navigate = useNavigate();

  return (
    <Modal>
      <div className="flex flex-col items-center justify-center px-5">
        <div className="mb-5">
          <Envelope height={100} />
        </div>
        <p className="text-black whitespace-normal text-center mb-5">
          If this is a valid email address we have sent a password reset email. Please check your email and click the link to reset your password.
        </p>
        <CTAButton
          label="Back to Login"
          onPress={() => {
            navigate('/', {replace: true});
          }}
        />
      </div>
    </Modal>
  );
};
